var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Grid, Modal } from "semantic-ui-react";
import { MetaCatalogLoader } from "../kit/Catalog";
import { RelevantCatalogType } from "../kit/rna-cish/RnaCatalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { CatalogMode } from "../RequestHelpers";
import CreateOrderForUser from "./CreateOrderForUser";
var ProStarterKitForm = /** @class */ (function (_super) {
    __extends(ProStarterKitForm, _super);
    function ProStarterKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.starterKitPage = function (catalog) {
            var protocols = catalog.rnaCatalog.cishProtocols;
            var organisms = catalog.rnaCatalog.probeSet.catalog.organisms.filter(function (o) { return o.name === 'Mouse' || o.name === 'Human'; });
            var ampCatalog = catalog.rnaCatalog.cishAmplifier;
            var enzymes;
            if (_this.state.protocolType != null) {
                enzymes = ampCatalog
                    .amplifierConfig
                    .filter(function (c) { return c.protocolType.id === _this.state.protocolType.id; });
            }
            else {
                // If the protocol type is not selected show the leica configurations as the default until the user
                // selects a protocol type
                enzymes = ampCatalog
                    .amplifierConfig
                    .filter(function (c) { return c.protocolType.id === "LEICA"; });
            }
            return React.createElement("div", { className: 'enzymatic-ish-form' },
                React.createElement(Grid, { columns: 2, verticalAlign: "middle" },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { textAlign: "center", width: 12 },
                            React.createElement("h1", { className: "ish-primary-header" }, "HCR\u2122 Kit Designer"),
                            React.createElement("h1", { className: "ish-subheader" }, "Build your RNA-ISH Kit")))),
                React.createElement(Grid, { columns: 4, verticalAlign: "middle" },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Platform")),
                        protocols.filter(function (p) { return p.id !== 'MANUAL'; }).map(function (p, index) {
                            var _a, _b;
                            return React.createElement(React.Fragment, { key: index },
                                React.createElement(Grid.Column, { width: 4, key: index, textAlign: "right" },
                                    React.createElement(Button, { className: (p.id === ((_a = _this.state.protocolType) === null || _a === void 0 ? void 0 : _a.id)) ? "button-box selected-ish" : "button-box", tabIndex: p.id, onClick: _this.onProtocolChange(catalog) },
                                        React.createElement("p", { className: ((_b = _this.state.protocolType) === null || _b === void 0 ? void 0 : _b.id) === p.id ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, p.alias === "ONCORE Pro X" ? React.createElement(React.Fragment, null, "ONCORE Pro\u00A0X") : p.alias))));
                        }))),
                React.createElement(Grid, { columns: 2, verticalAlign: "middle" },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Organism")),
                        organisms.map(function (o, index) {
                            return React.createElement(React.Fragment, { key: index },
                                React.createElement(Grid.Column, { width: 6, key: index, textAlign: "right" },
                                    React.createElement(Button, { className: _this.state.libraryOrganism === o ? "button-box selected-ish" : "button-box", tabIndex: o.name, onClick: _this.onOrganismChange(catalog) },
                                        React.createElement("p", { className: _this.state.libraryOrganism === o ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, o.name))));
                        }))),
                React.createElement(Grid, { columns: 4, verticalAlign: "middle", textAlign: "center", padded: false },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Enzyme")),
                        enzymes.sort(function (c) {
                            if (c.displayName === "HRP") {
                                return -1;
                            }
                            else if (c.displayName === "AP") {
                                return 0;
                            }
                            else {
                                return 1;
                            }
                        }).map(function (c, index) {
                            var _a;
                            return React.createElement(Grid.Column, { key: index, width: 4 },
                                React.createElement(Button, { className: ((_a = _this.state.enzymeCompatibility) === null || _a === void 0 ? void 0 : _a.id) === c.id ? "button-box selected-ish" : "button-box", tabIndex: c.id, onClick: _this.onEnzymeCompatibilityChange(catalog) },
                                    React.createElement("p", { className: _this.state.enzymeCompatibility === c ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, c.displayName),
                                    _this.enzymeLabels(c, _this.state.enzymeCompatibility === c)));
                        }),
                        React.createElement(Grid.Column, { width: 1 }))),
                React.createElement(Grid, { columns: 1, textAlign: "right" },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement(Modal, { closeIcon: true, onClose: _this.render, trigger: React.createElement(Button, { icon: 'magic', label: 'Create order for another user', labelPosition: 'left', disabled: _this.state.protocolType == null || _this.state.enzymeCompatibility == null || _this.state.libraryOrganism == null }) },
                                React.createElement(Modal.Header, null, "Create an order from your cart for another user"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(CreateOrderForUser, { starterKitFormState: _this.state })))))));
        };
        _this.onProtocolChange = function (catalog) { return function (event, data) {
            var pt = data.tabIndex;
            var selectedProtocol = catalog.rnaCatalog.cishProtocols.find(function (p) {
                return p.id === pt;
            });
            var selectedEnzyme = catalog.rnaCatalog.cishAmplifier
                .amplifierConfig
                .find(function (c) {
                var _a, _b;
                return c.protocolType.id === (selectedProtocol === null || selectedProtocol === void 0 ? void 0 : selectedProtocol.id) &&
                    c.displayName.trim() === ((_b = (_a = _this.state.enzymeCompatibility) === null || _a === void 0 ? void 0 : _a.displayName) === null || _b === void 0 ? void 0 : _b.trim());
            });
            _this.setState(function () { return ({
                protocolType: selectedProtocol,
                enzymeCompatibility: selectedEnzyme
            }); });
        }; };
        _this.onEnzymeCompatibilityChange = function (catalog) { return function (event, data) {
            var cc = data.tabIndex;
            var selectedEnzyme = catalog.rnaCatalog.cishAmplifier.amplifierConfig
                .filter(function (c) {
                var _a;
                if (_this.state.protocolType != null) {
                    return c.protocolType.id === ((_a = _this.state.protocolType) === null || _a === void 0 ? void 0 : _a.id);
                }
                else {
                    return true;
                }
            })
                .find(function (c) { return c.id === cc; });
            _this.setState(function () { return ({
                enzymeCompatibility: selectedEnzyme
            }); });
        }; };
        _this.onOrganismChange = function (catalog) { return function (event, data) {
            var organism = data.tabIndex;
            var selectedOrganism = catalog.rnaCatalog.probeSet.catalog.organisms.find(function (o) { return o.name === organism; });
            _this.setState(function () { return ({
                libraryOrganism: selectedOrganism
            }); });
        }; };
        _this.enzymeLabels = function (config, selected) {
            if (config.antiHapten2Ap.id !== "NONE" && config.antiHapten2Hrp.id !== "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(+$15/slide)"));
            }
            else if (config.antiHapten2Ap.id !== "NONE" && config.antiHapten2Hrp.id === "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., Fast Red)"));
            }
            else if (config.antiHapten2Ap.id === "NONE" && config.antiHapten2Hrp.id !== "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., DAB, TSA Fluors)"));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.state = {
            protocolType: undefined,
            libraryOrganism: undefined,
            enzymeCompatibility: undefined
        };
        return _this;
    }
    ProStarterKitForm.prototype.render = function () {
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial), render: this.starterKitPage });
    };
    return ProStarterKitForm;
}(React.PureComponent));
export default ProStarterKitForm;
//# sourceMappingURL=ProStarterKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProStarterKitForm.js
// module id = 1333
// module chunks = 0